import { Link } from "gatsby";
import PageSection from "@components/PageSection";
import { FlexBox, Text } from "@styles";
import React, { useMemo, useState } from "react";
import SafeImage from "@components/SafeImage";
import { GetThumbnailImage } from "@services/ProductImages";

import { GetColorLineMap } from "@services/ProductList";
import { Dropdown, DropdownButton, DropdownItem, DropdownLabel, DropdownMenu } from '@components/Catalyst/dropdown'
import  { Button } from '@components/Catalyst/button'
import { ChevronDownIcon, CheckIcon } from '@heroicons/react/16/solid'


interface Props {
  sets: Queries.ProductFragment[];
  pageGroupKey?: string;   // we use this to filter the available group filters
  tileMaxWidth?: number;
}

const SetTiles = ({ sets, pageGroupKey, tileMaxWidth = 325 }: Props) => {
  
  const [displayedGroupKey, setDisplayedGroupKey] = useState<string>("");
  const [ showAllSets, setShowAllSets ] = useState<boolean>(false);  

  const productGroupList = useMemo( () => {
    // grab the color lines, remove the colorLine we're trying to
    const colorLines = GetColorLineMap(sets);

    return [{ label: "All Sets", value: "" }, 
     ...[...colorLines.entries()]
      .filter (([key, _]) => key !== pageGroupKey)
      .map(([key, value]) => ({ label: value.name, value: key }))];
  }, []);

  const showGroupFilter = productGroupList.length > 1;  


  const filteredSets = sets
       .filter((p) => !displayedGroupKey || p.product_groups.find( pg => pg.id === displayedGroupKey ))
       .sort((a, b) =>
            (a?.item_parents?.[0]?.friendly_item_number ?? "zzzzz").localeCompare(b?.item_parents?.[0]?.friendly_item_number ?? "zzzzz"),
          )

  const setsLimit = filteredSets.length >  21 && !showAllSets;

  const displaySets = setsLimit ? filteredSets.slice(0, 18) : filteredSets;
  

  
  return (
  <PageSection sectionName="Sets">
    <FlexBox justifyContent="center" direction="column" alignItems="center">

       {showGroupFilter  && (
          <FlexBox direction="row" alignItems="center" justifyContent="space-between" width="100%">
            <FlexBox alignItems="center">
            
              <Dropdown>
                <DropdownButton outline>
                  Filter 
                  <ChevronDownIcon />
                </DropdownButton>
                <DropdownMenu>
                 
             
                  {productGroupList.map((group) => (

                    <DropdownItem key={group.value} onClick={() => setDisplayedGroupKey(group.value)}>
                      {displayedGroupKey === group.value && <CheckIcon /> }
                      <DropdownLabel>{group.label}</DropdownLabel>
                    </DropdownItem>
                  ))}

                  </DropdownMenu>
              </Dropdown>



            </FlexBox>
          </FlexBox>
       )}


      <FlexBox flexWrap justifyContent="center" maxWidth={tileMaxWidth} gap={3}>
        {displaySets.map((p) => {
            const thumbnail = GetThumbnailImage(p);
            return (
              <Link to={`/products/${p.slug}`} key={p.product_name} style={{ textDecoration: "none" }}>
                <FlexBox
                  direction="column"
                  width={`${tileMaxWidth}px`}
                  justifyContent="center"
                  alignItems="center"
                  key={p.product_name}
                  gap={0.25}
                >
                  <SafeImage src={thumbnail?.fullImageUrl} alt={thumbnail?.altText} style={{ width: "100%" }} />

                  <Text as="h4" color="black" style={{ textAlign: "center", padding: "0rem" }}>
                    {p?.product_name ?? ""} <br />
                  </Text>
                  <span style={{ fontSize: ".9rem", color: "black" }}>{p.item_parents.map((ip) => `${ip.friendly_item_number} `)}</span>

                  <FlexBox color="black" style={{ textAlign: "center", fontSize: "0.9rem" }}>
                    {p?.translations?.[0]?.brief_description ?? ""}
                  </FlexBox>
                </FlexBox>
              </Link>
            );
          })}
           
      </FlexBox>
      {setsLimit && <Button onClick={() => setShowAllSets(true)}>See All</Button>}
    </FlexBox>
  </PageSection>
)
}
export default SetTiles;
